import {LoaiKhuVucService} from '@entities/loai-khu-vuc/loai-khu-vuc.service';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [LoaiKhuVucService],
})
export class LoaiKhuVucModule {}
